module.exports = __webpack_public_path__ + "static/media/home2.da726c52.png";